import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@hover/blueprint';
import { usePlayMobileAndTabletVideo } from '../../../hooks';
import PlayVideoButton from '../../../assets/svgs/PlayVideoButton';
import PauseVideoButton from '../../../assets/svgs/PauseVideoButton';
import { IElementWithVideo } from '../../../interfaces/IElementWithVideo';

interface Props extends IElementWithVideo {}

const StyledButtonWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.6;
`;

const StyledWrapper = styled(Box)`
  video[poster] {
    aspect-ratio: 2.6;
    object-fit: cover;
  }
`;

const FullWidthHeroVideo: React.FC<Props> = ({
  showOnDesktop,
  hideControls,
  autoPlay,
  videoSrcs,
  poster,
}) => {
  const { videoRef, paused, showButton, onPlay } =
    usePlayMobileAndTabletVideo();

  const renderButton = (): React.ReactNode | null => {
    if (paused) return <PlayVideoButton />;
    if (showButton) return <PauseVideoButton />;
    return null;
  };
  return (
    <StyledWrapper
      d={{ base: 'flex', desktop: showOnDesktop ? 'flex' : 'none' }}
      position="relative"
      onClick={onPlay}
      w="100%"
    >
      <video
        autoPlay={autoPlay}
        ref={videoRef}
        width="100%"
        poster={poster}
        loop
        playsInline
        muted
      >
        {videoSrcs.map(({ src, type }) => (
          <source src={src} type={type} key={type} />
        ))}
      </video>
      {!hideControls && (
        <StyledButtonWrapper>{renderButton()}</StyledButtonWrapper>
      )}
    </StyledWrapper>
  );
};

export default FullWidthHeroVideo;
